import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import _noop from 'lodash/noop';

// Components
import ActionsList from '../../../../actionsList';

// Helpers
import { getVisibleActionCount, getActionsForRow } from './actionCellRenderer.helpers';
var ActionCellRenderer = /*#__PURE__*/function (_PureComponent) {
  _inherits(ActionCellRenderer, _PureComponent);
  var _super = _createSuper(ActionCellRenderer);
  function ActionCellRenderer() {
    var _this;
    _classCallCheck(this, ActionCellRenderer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getActionsForRow", defaultMemoize(getActionsForRow));
    _defineProperty(_assertThisInitialized(_this), "handleActionClick", function (actionType) {
      var _this$props = _this.props,
        onRowActionClick = _this$props.onRowActionClick,
        original = _this$props.original;
      onRowActionClick(actionType, original);
    });
    return _this;
  }
  _createClass(ActionCellRenderer, [{
    key: "render",
    value: function render() {
      var actions = this.props.value;
      var visibleActionCount = getVisibleActionCount(actions);
      return /*#__PURE__*/React.createElement(ActionsList, {
        actions: actions,
        visibleActionCount: visibleActionCount,
        onActionClick: this.handleActionClick
      });
    }
  }]);
  return ActionCellRenderer;
}(PureComponent);
ActionCellRenderer.propTypes = {
  onRowActionClick: PropTypes.func,
  original: PropTypes.object.isRequired,
  value: PropTypes.array.isRequired
};
ActionCellRenderer.defaultProps = {
  onRowActionClick: _noop
};
export default ActionCellRenderer;